import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import _memoize from 'lodash/memoize';
import { makeDefaultStylingContext } from '../../../../utils/style';
import { middle } from '../../../../utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const sizes = {
  [HD]: {
    iconsRow: {
      w: 1000,
      h: 32,
    },
    icon: {
      h: 32,
    },
    programLogo: {
      w: 251,
      h: 157,
    },
    extraDetails: {
      w: 460,
    },
    title: {
      w: 460,
    },
  },
  [FULL_HD]: {
    iconsRow: {
      w: 1000,
      h: 40,
    },
    icon: {
      h: 40,
    },
    programLogo: {
      w: 382,
      h: 215,
    },
    extraDetails: {
      w: 688,
    },
    title: {
      w: 688,
    },
  },
};

export const margins = {
  [HD]: {
    serviceIcon: {
      marginRight: 8,
    },
    extraDetails: {
      marginRight: 12,
    },
  },
  [FULL_HD]: {
    serviceIcon: {
      marginRight: 12,
    },
    extraDetails: {
      marginRight: 16,
    },
  },
};

export const paddings = {
  [HD]: {
    title: {
      paddingTop: 16,
    },
    iconsRow: {
      paddingTop: 16,
    },
  },
  [FULL_HD]: {
    title: {
      paddingTop: 16,
    },
    iconsRow: {
      paddingTop: 24,
    },
  },
};

export const getSizes = (screenSize = FULL_HD) => sizes[screenSize];

export const getMargins = (screenSize = FULL_HD) => margins[screenSize];

export const getPaddings = (screenSize = FULL_HD) => paddings[screenSize];

export const getTitleFont = _memoize(screenSize => getFont(FONT.PARIS_3, screenSize));

export const getExtraDetailsFont = _memoize(screenSize => getFont(FONT.BERLIN_1, screenSize));

export const getInitialStyle = ({ screenSize } = defaultContext) => {
  const sizes = getSizes(screenSize);
  const margins = getMargins(screenSize);
  const paddings = getPaddings(screenSize);

  return {
    flex: {
      direction: 'column',
      justifyContent: 'flex-end',
    },
    ProgramLogo: {
      w: sizes.programLogo.w,
      h: sizes.programLogo.h,
      Logo: {
        mountY: 0.5,
        y: middle,
      },
    },
    Incentive: {},
    Title: {
      flexItem: { marginTop: paddings.title.paddingTop },
      text: {
        ...getTitleFont(screenSize),
        verticalAlign: 'middle',
        wordWrapWidth: sizes.title.w,
        maxLines: 2,
        maxLinesSuffix: '...',
      },
    },
    IconsRow: {
      h: sizes.iconsRow.h,
      flexItem: { marginTop: paddings.iconsRow.paddingTop },
      flex: {
        direction: 'row',
        alignItems: 'center',
      },
      ExtraDetails: {
        text: {
          ...getExtraDetailsFont(screenSize),
          verticalAlign: 'middle',
          wordWrapWidth: sizes.extraDetails.w,
          maxLines: 1,
          maxLinesSuffix: '...',
        },
        flexItem: {
          marginRight: margins.extraDetails.marginRight,
        },
      },
      CsaIcon: {},
    },
  };
};
